import { User } from "@auth0/auth0-react";
import { useEffect } from "react";

declare global {
  interface Window {
    pendo?: {
      isReady: () => boolean;
      updateOptions: (params: Record<string, unknown>) => void;
      initialize: (params: Record<string, unknown>) => void;
      showGuideById: (guideId: string) => void;
      track: (eventName: string, metadata?: Record<string, unknown>) => void;
    };
  }
}

interface PendoOptions {
  visitor?: Record<string, unknown>;
  account?: Record<string, unknown>;
}

export function usePendoSetup(options: PendoOptions) {
  const { visitor, account } = options;

  useEffect(() => {
    if (!visitor) {
      return;
    }

    if (!window.pendo) {
      return;
    }

    if (window.pendo.isReady()) {
      window.pendo.updateOptions({
        visitor,
        account,
      });
    } else {
      window.pendo.initialize({
        visitor,
        account,
        // We want to track anonymous visitors across subdomains or apps, so we need to set the cookie domain.
        // See: https://support.pendo.io/hc/en-us/articles/360037760572-Track-anonymous-visitors-across-subdomains-or-apps
        cookieDomain: ".certn.co",
      });
    }
  }, [visitor, account]);
}

export function showPendoGuideById(guideId: string) {
  window.pendo?.showGuideById(guideId);
}

export function auth0UserToVisitor(user?: User) {
  return {
    id: user?.sub,
  };
}
